module.exports = __webpack_public_path__ + "static/media/HAnd@1.5x.165e3a33.svg";